export default {
  inserted: function (el: any, binding: any) {
    const f = function (evt: any) {
      if (binding.value(evt, el)) {
        window.removeEventListener('resize', f)
      }
    }
    window.addEventListener('resize', f)
  }
}
